import { Component, Input } from "@angular/core";
import { Report } from "../../models/report.interface";

@Component({
  selector: "icr-report-data",
  templateUrl: "./report-data.component.html",
  styleUrls: ["report-data.component.scss"],
  standalone: false,
})
export class ReportDataComponent {
  @Input() data: Report[] = [];
}
